import React from "react";
import AjudaModal from "./AjudaModal";

function AjudaRecursos({ pestanya, onTancar }) {
  const contingut = CONTINGUT[pestanya] || CONTINGUT.vehicles;
  return (
    <AjudaModal id="recursos-ajuda-title" titol={contingut.titol} lead={contingut.lead} onTancar={onTancar}>
      {contingut.cos}
    </AjudaModal>
  );
}

const LLISTA_COMUNA = (
  <section className="dv2-help-section">
    <h4>Llista</h4>
    <ul>
      <li>Doble clic a la fila per consultar. El menú <strong>…</strong> obre Consultar, Modificar i Desactivar o Reactivar.</li>
      <li>El filtre <strong>Estat</strong> mostra per defecte només els actius; canvia'l per veure els inactius o tots.</li>
      <li>Clica una capçalera de columna per ordenar. A pantalla estreta la llista es mostra en targetes.</li>
    </ul>
  </section>
);

const BAIXA_LOGICA = (
  <section className="dv2-help-section">
    <h4>Desactivar no esborra</h4>
    <p>
      Cap registre s'esborra mai. Desactivar el treu dels llistats d'actius però en conserva totes les dades i
      l'historial, i es pot reactivar quan calgui.
    </p>
  </section>
);

const IMATGE = (
  <section className="dv2-help-section">
    <h4>Imatge</h4>
    <p>
      És opcional i funciona igual que a Productes: s'escull un fitxer (JPG, PNG, GIF o WEBP), es redueix
      automàticament i es mostra una previsualització. Es pot substituir per una altra o treure-la.
    </p>
  </section>
);

const CONTINGUT = {
  vehicles: {
    titol: "Com funcionen els Vehicles",
    lead: "El parc de vehicles de l'empresa: dades, manteniment i assegurança en un sol lloc.",
    cos: (
      <>
        {LLISTA_COMUNA}
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <ul>
            <li>Només es veuen els vehicles de l'empresa activa, i els nous s'hi assignen.</li>
            <li>La <strong>matrícula</strong> és obligatòria i no es pot repetir.</li>
            <li>
              Les dates de <strong>propera ITV</strong>, <strong>propera revisió</strong> i
              <strong> venciment de l'assegurança</strong> es marquen en vermell si ja han passat i en taronja si
              vencen en menys de 30 dies.
            </li>
            <li>El telèfon d'urgències de l'asseguradora es desa com a text: admet prefixos i espais.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Ubicació logística</h4>
          <p>
            Cada vehicle té automàticament una ubicació de tipus Vehicle (per poder-hi moure eines i material). No
            cal crear-la: es crea en donar d'alta el vehicle, es manté en editar-lo i es desactiva amb ell sense
            perdre'n els moviments.
          </p>
        </section>
        {IMATGE}
        {BAIXA_LOGICA}
      </>
    ),
  },
  eines: {
    titol: "Com funcionen les Eines",
    lead: "Les eines són actius reutilitzables de l'empresa, independents de qualsevol treball concret.",
    cos: (
      <>
        {LLISTA_COMUNA}
        <section className="dv2-help-section">
          <h4>Estat i Activa</h4>
          <ul>
            <li>Només es veuen les eines de l'empresa activa, i les noves s'hi assignen.</li>
            <li><strong>Estat</strong> és la situació operativa: operativa, avariada, en reparació, baixa o perduda.</li>
            <li><strong>Activa</strong> indica si l'eina continua dins del parc habitual. Una eina inactiva es conserva amb tot l'historial.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Ubicació actual</h4>
          <p>
            És informativa: es dedueix de l'últim moviment registrat de l'eina i no es desa a la fitxa. Si encara no
            té moviments, es mostra "Sense moviments".
          </p>
        </section>
        {IMATGE}
        {BAIXA_LOGICA}
      </>
    ),
  },
  magatzems: {
    titol: "Com funcionen els Magatzems",
    lead: "Els magatzems de l'empresa, amb la seva adreça i la persona responsable.",
    cos: (
      <>
        {LLISTA_COMUNA}
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <ul>
            <li>El magatzem pertany sempre a l'empresa activa.</li>
            <li>
              L'<strong>adreça</strong> és obligatòria (via, població, província, país i codi postal). Si ja existeix
              una adreça idèntica a l'aplicació es reaprofita; si no, se'n crea una de nova sense tocar les existents.
            </li>
            <li>El <strong>responsable</strong> es tria entre els usuaris de l'empresa.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Ubicació logística</h4>
          <p>
            Cada magatzem té automàticament una ubicació de tipus Magatzem. No cal crear-la: es crea en donar d'alta
            el magatzem, es manté en editar-lo i es desactiva amb ell sense perdre'n els moviments.
          </p>
        </section>
        {IMATGE}
        {BAIXA_LOGICA}
      </>
    ),
  },
};

export default AjudaRecursos;
